import React, { useState } from "react";
import {
  ActiveCheckbox,
  EditButton,
  DeleteButton,
} from "../../common/TableCols";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Table, Button, Spin, Card, Row, Col } from "antd";
import PropTypes from "prop-types";
import { RecordType } from "../../model/common/RecordType";
import FilterGridDropdown from "../../common/FilterGridDropdown";
import EntryFormFooter from "../../common/EntryFormFooter";
import { useTranslation } from "react-i18next";

export const LeaveTypesForm = ({
  isLoading,
  leaveTypes,
  onAdd,
  onEdit,
  onDelete,
  onRowSelected,
  rowSelected,
  setCurrentPage,
  currentPage,
}) => {
  const { t } = useTranslation();
  const LeaveTypeActiveCheckbox = (value) => (
    <ActiveCheckbox isChecked={value} />
  );

  const [searchText, setSearchText] = useState("");

  const LeaveTypeActionButtons = (value, record) => (
    <Row>
      <Col span={12}>
        <EditButton fncEdit={() => onEdit(value)} />
      </Col>
      <Col
        span={12}
        style={{
          display: record.RcdType === RecordType.USER ? "" : "none",
        }}
      >
        <DeleteButton fncDelete={() => onDelete(value)} />
      </Col>
    </Row>
  );

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: t("leaveTypesForm.leave_type_code"),
      dataIndex: "LTCode",
      key: "LTCode",
      width: 200,
      sorter: (a, b) => a.LTCode.localeCompare(b.LTCode),
      sortDirections: ["ascend", "descend"],
      ...FilterGridDropdown(
        "LTCode",
        searchText,
        handleSearch,
        handleReset,
        "Leave Type Code",
        t
      ),
    },
    {
      title: t("general.description"),
      dataIndex: "LTDesc",
      key: "LTDesc",
      sorter: (a, b) => a.LTDesc.localeCompare(b.LTDesc),
      sortDirections: ["ascend", "descend"],
      ...FilterGridDropdown(
        "LTDesc",
        searchText,
        handleSearch,
        handleReset,
        "Description",
        t
      ),
    },
    {
      title: t("general.active"),
      dataIndex: "Active",
      key: "Active",
      align: "center",
      width: 100,
      render: LeaveTypeActiveCheckbox,
    },
    {
      title: t("general.action"),
      dataIndex: "LTKey",
      key: "LeaveTypeActions",
      align: "center",
      width: 100,
      render: LeaveTypeActionButtons,
    },
  ];

  const tablePaginationChanged = (page) => {
    setCurrentPage(page);
  };

  return (
    <Card
      title={
        <span className="form-title">
          {t("leaveTypesForm.leave_type_setup")}
        </span>
      }
      extra={
        <Button
          icon={<PlusCircleOutlined />}
          size="large"
          type="primary"
          style={{ border: "1px solid #fff" }}
          onClick={() => onAdd()}
        >
          {t("general.new")}
        </Button>
      }
    >
      <Spin spinning={isLoading}>
        <Table
          dataSource={leaveTypes}
          columns={columns}
          size="middle"
          pagination={{
            defaultCurrent: currentPage,
            onChange: tablePaginationChanged,
          }}
          rowKey={(record) => record.LTKey}
          scroll={{ y: "calc(100vh - 270px)" }}
          onRow={(r) => ({ onClick: () => onRowSelected(r) })}
        />
      </Spin>
      <EntryFormFooter
        footerData={rowSelected}
        showFooter={rowSelected.UpdatedBy ? true : false}
        isApproved={false}
        isVoid={false}
        isPending={false}
        t={t}
      ></EntryFormFooter>
    </Card>
  );
};

LeaveTypesForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  leaveTypes: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRowSelected: PropTypes.func.isRequired,
  rowSelected: PropTypes.object.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
};

export default LeaveTypesForm;
